class FacetFiltersForm extends HTMLElement {
  constructor() {
    super()
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this)

    this.submitButton = this.querySelector('[data-submit]')
    if(this.submitButton) {
      this.submitButton.addEventListener('click', (e) => {
        e.preventDefault()
        this.onSubmitHandler(event)
        this.closest('menu-drawer').onCloseButtonClick(event)
      })
    }

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form')
    facetForm.addEventListener('input', (e) => {
      if(e.target.getAttribute('type') == 'text') {
        this.debouncedOnSubmit(e)
      } else {
        this.onSubmitHandler(e)
      }
    })
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial
      if (searchParams === FacetFiltersForm.searchParamsPrev) return
      FacetFiltersForm.renderPage(searchParams, null, false)
    }
    window.addEventListener('popstate', onHistoryChange)
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable)
    })
  }

  static loadFilters(searchParams, event) {

    const facetsFormInner = document.querySelector('.mobile-facets__inner')
    facetsFormInner.classList.add('loading')

    FacetFiltersForm.searchParamsPrev = searchParams
    const sections = FacetFiltersForm.getSections()

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`
      const filterDataUrl = (element) => element.url === url

      if(FacetFiltersForm.filterData.some(filterDataUrl)) {
        const html = FacetFiltersForm.filterData.find(filterDataUrl).html
        FacetFiltersForm.renderFilters(html, event)
        facetsFormInner.classList.remove('loading')
      } else {
        fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            const html = responseText
            FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }]
            FacetFiltersForm.renderFilters(html, event)
          })
          .finally(() => {
            facetsFormInner.classList.remove('loading')
          })
      }
    })

  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams
    const sections = FacetFiltersForm.getSections()
    const countContainer = document.getElementById('ProductCount')
    const countContainerDesktop = document.getElementById('ProductCountDesktop')
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    )
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'))
    document.getElementById('ProductGridContainer').querySelector('[data-collection]').classList.add('loading')
    if (countContainer) {
      countContainer.classList.add('loading')
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading')
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`
      const filterDataUrl = (element) => element.url === url

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event)
    })

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

  }

  static renderSectionFromFetch(url, event) {
    console.log('renderSectionFromFetch')
    // console.log(event)

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }]

        FacetFiltersForm.renderFilters(html, event)
        FacetFiltersForm.renderProductGridContainer(html)
        FacetFiltersForm.renderProductCount(html)
      })
  }

  static renderSectionFromCache(filterDataUrl, event) {
    console.log('renderSectionFromCache')
    // console.log(event)

    const html = FacetFiltersForm.filterData.find(filterDataUrl).html
    FacetFiltersForm.renderFilters(html, event)
    FacetFiltersForm.renderProductGridContainer(html)
    FacetFiltersForm.renderProductCount(html)
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel')
      })
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount')
    const containerDesktop = document.getElementById('ProductCountDesktop')
    container.innerHTML = count
    container.classList.remove('loading')
    if (containerDesktop) {
      containerDesktop.innerHTML = count
      containerDesktop.classList.remove('loading')
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    )
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'))
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html')
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersFormMobile .js-filter'
    )
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersFormMobile .js-filter'
    )

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove()
      }
    })

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined
      return jsFilter ? element.id === jsFilter.id : false
    }

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element))
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId)

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id)
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1]
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender)
            return
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender)
        }
      }
    })

    FacetFiltersForm.renderAdditionalElements(parsedHTML)

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id

      if (closestJSFilterID) {
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID))

        const newFacetDetailsElement = document.getElementById(closestJSFilterID)
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector)

        const isTextInput = event.target.getAttribute('type') === 'text'

        if (newElementToActivate && !isTextInput) newElementToActivate.focus()
      }
    }
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open--static', '.mobile-facets__open--floating']

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML
    })

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents()
  }

  static renderMobileCounts(source, target) {

    // console.log(source)

    const targetFacetsList = target.querySelector('.mobile-facets__list')
    const sourceFacetsList = source.querySelector('.mobile-facets__list')

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML
    }

    const targetFacetsSummaryInner = target.querySelector('.current-filters-count')
    const sourceFacetsSummaryInner = source.querySelector('.current-filters-count')

    if (sourceFacetsSummaryInner && targetFacetsSummaryInner) {
      targetFacetsSummaryInner.outerHTML = sourceFacetsSummaryInner.outerHTML
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`)
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form)
    return new URLSearchParams(formData).toString()
  }

  onChangeFilters(searchParams, event) {
    FacetFiltersForm.loadFilters(searchParams, event)
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event)
  }

  onSubmitHandler(event) {
    console.log('onSubmitHandler')
    event.preventDefault()
    // const sortFilterForms = document.querySelectorAll('facet-filters-form form')
    const searchParams = this.createSearchParams(event.target.closest('form'))
    // console.log(searchParams)
    if (event.srcElement.className == 'mobile-facets__checkbox' || event.srcElement.className == 'mobile-facets__number-input') {
      // console.log('mobile-facets__checkbox')
      this.onChangeFilters(searchParams, event)
    } else {
      this.onSubmitForm(searchParams, event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault()
    FacetFiltersForm.toggleActiveFacets()
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1)
    // FacetFiltersForm.renderPage(url)
    FacetFiltersForm.loadFilters(url)
  }

}

FacetFiltersForm.filterData = []
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1)
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1)
customElements.define('facet-filters-form', FacetFiltersForm)
FacetFiltersForm.setListeners()


class PriceRange extends HTMLElement {
  constructor() {
    super()

    // set inputs default values
    const inputs = Array.from(this.querySelectorAll('input'))
    const minInput = inputs[0]
    const maxInput = inputs[1]

    const min = Number(minInput.getAttribute('data-min').replace(',','.'))
    const max = Number(maxInput.getAttribute('data-max').replace(',','.'))

    // create and set slider values
    let slider = this.querySelector('[data-price-slider]')

    noUiSlider.create(slider, {
      start: [
        Number(minInput.value.replace(',','.')),
        (maxInput.value !== '') ? Number(maxInput.value.replace(',','.')) : max
      ],
      connect: [false, true, false],
      range: {
        'min': 0,
        'max': max
      }
    })

    const facetForm = this.closest('form')
    const facetFiltersForm = this.closest('facet-filters-form')

    const myInputEvent = new InputEvent('input', {
      bubbles: true,
      cancelable: false
    });

    slider.noUiSlider.on('change', function(values, handle) {
      inputs[handle].value = values[handle].replace('.',',')
      minInput.dispatchEvent(myInputEvent)
      maxInput.dispatchEvent(myInputEvent)
    })

    const debounceInputChange = debounce((handle, value) => {
      // console.log(value)
      slider.noUiSlider.setHandle(handle, value)
    }, 800);

    inputs.forEach(function (input, handle) {
      input.addEventListener('input', function(event) {
        debounceInputChange(handle, input.value.replace(',','.'))
      })
    })

  }

}

customElements.define('price-range', PriceRange)


class AvailabilityToggle extends HTMLElement {
  constructor() {
    super()

    this.button = this.querySelector('[data-toggle]')
    this.input = this.querySelector('input')
    if(this.button && this.input) {
      this.button.addEventListener('click', (e) => {
        e.preventDefault()
        this.input.checked = !this.input.checked
        const myInputEvent = new InputEvent('input', {
          bubbles: true,
          cancelable: false
        })
        this.input.dispatchEvent(myInputEvent)
        this.classList.toggle('availability-toggle--active')
      })
    }
  }
}

customElements.define('availability-toggle', AvailabilityToggle)


class FacetRemove extends HTMLElement {
  constructor() {
    super()
    const facetLink = this.querySelector('a')
    facetLink.setAttribute('role', 'button')
    facetLink.addEventListener('click', this.closeFilter.bind(this))
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault()
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event)
    })
  }

  closeFilter(event) {
    event.preventDefault()
    const form = this.closest('facet-filters-form')
    form.onActiveFilterClick(event)
  }
}

customElements.define('facet-remove', FacetRemove)

